<template>
  <div class="PageBox" style="background: url('./static/images/bj@2x.png');background-size: 100% 100%;height: 100%;width: 100%;">
    <div class="ScrollBox">
		<van-nav-bar
		    fixed
		    :border="false"
		    :right-text="$t('wallet.default[0]')"
		    left-arrow
		    @click-left="$router.go('-1')"
			@click-right="$router.push('/user/wallet')"
		/>
		<van-grid class="MyEarnings" :border="false" :column-num="3" style="margin-left:10px; margin-right:10px;border-radius:5px;background-color: rgba(255,255,255,0.1);">
		  <van-grid-item>
		    <template #icon>
		    {{ $t("user.myEarnings.grid[6]") }}({{ InitData.currency }})
		    </template>
		    <template #text>
		    {{ UserInfo.total_profit }}
		    </template>
		</van-grid-item>
		  <van-grid-item>
		    <template #icon>
		      {{ $t("user.myEarnings.grid[2]") }}({{ InitData.currency }})
		    </template>
		    <template #text>
		      {{ UserInfo.today_earnings }}
		    </template>
		  </van-grid-item>
		  <van-grid-item>
		    <template #icon>
		      {{ $t("user.myEarnings.grid[3]") }}({{ InitData.currency }})
		    </template>
		    <template #text>
		      {{ UserInfo.week_earnings }}
		    </template>
		  </van-grid-item>
		  <van-grid-item>
		    <template #icon>
		      {{ $t("user.myEarnings.grid[4]") }}({{ InitData.currency }})
		    </template>
		    <template #text>
		      {{ UserInfo.month_earnings }}
		    </template>
		  </van-grid-item>
		  <van-grid-item>
		          <template #icon>
		            {{ $t("user.myEarnings.grid[11]") }}
		          </template>
		          <template #text>
		            {{ UserInfo.today_spread || "0" }}
		          </template>
		        </van-grid-item>
		  <van-grid-item>
		    <template #icon>
		      {{ $t("user.myEarnings.grid[9]") }}
		    </template>
		    <template #text>
		      {{ UserInfo.today_commission || "0" }}
		    </template>
		  </van-grid-item>
		        <van-grid-item>
		          <template #icon>
		            {{ $t("user.myEarnings.grid[10]") }}
		          </template>
		          <template #text>
		            {{ UserInfo.today_rebate || "0" }}
		          </template>
		        </van-grid-item>
		</van-grid>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fund',
  components: {
  },
  props: [],
  data() {
    return {
      UserInfo:''
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
	this.$parent.navBarTitle =''
    this.$Model.GetUserData(data=>{
		this.UserInfo = data.info
	});
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
	  
  }
}
</script>
  <style scoped>
  .MyEarnings{
    margin-top: 80px;
  }
  .MyEarnings ::v-deep .van-grid-item {
    overflow: visible;
  }
  .MyEarnings ::v-deep .van-grid-item__content {
    box-shadow: none;
    border: none;
    border-radius: 0;
    color: #000;
  }
  .MyEarnings ::v-deep .van-grid-item__content {
    background-color:inherit;
    color: #FFF;
  }
  .MyEarnings ::v-deep .van-grid-item__icon-wrapper {
    color: #FFF;
  }
  </style>